<mc-dialog (closeEvent)="close()">
  <div class="container">
    <div class="content">
      <h3 class="title">Welcome to UserWay!</h3>
      <p class="sub-title">Your free accessibility trial starts now.</p>
      <ul class="steps-list">
        <li class="step-item">
          <mat-icon class="step-icon" svgIcon="check"></mat-icon>
          <p>
            Add the embed code below as the <b>first entry in your site’s &lt;head&gt; tag</b> to activate the Widget.
          </p>
        </li>
        <li class="step-item">
          <mat-icon class="step-icon" svgIcon="check"></mat-icon>
          <p>You can always find or manage the embed code in the <b>Overview</b> tab.</p>
        </li>
      </ul>
      <div class="embed-code-container">
        <div
          class="embed-code"
          [class.courier-font]="isWindowsOS"
          [innerHTML]="codeScriptContent()"
          data-testid="embed-code-script.window"
        ></div>
        <mc-button (click)="copyScript()" class="copy-btn" variant="icon" color="white">
          <mat-icon class="copy-icon" svgIcon="copy"></mat-icon>
        </mc-button>
      </div>
      <mc-button class="accept-btn" variant="flat" color="primary" (clickEvent)="close()">Got it</mc-button>
    </div>
    <div class="image-container">
      <img ngSrc="/assets/images/welcome-dialog.png" alt="Welcome modal" height="888" width="760" />
    </div>
  </div>
</mc-dialog>
